<template>
  <div class="soutai">
    <h3>早退申請</h3>
    <div class="col-item">
      <b class="title">月日</b>
      <p>{{ soutai?.start_date }}</p>
    </div>
    
    <div class="col-item">
      <b class="title">就業場所</b>
      <p>{{ form.syuugyou_basyo_name }}</p>
    </div>
    
    <div class="col-item">
      <b class="title">早退時刻</b>
      <p>{{ soutai?.start_time }}</p>
    </div>
    <div class="col-item">
      <b class="title">早退事由</b>
      <p>{{ form.shinsei_jiyuu }}</p>
    </div>
    <div class="col-item">
      <b class="title">備考</b>
      <p class="pre">{{ form.notes ?? '無し' }}</p>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import { Shinsei } from '@/types/Shinsei';

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
  },
  setup(props) {

    const soutai = props.form.soutai;

    return {
      soutai,
    }
  },
  components: {

  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>
